export const FAQ_CATEGORIES = [
  {
    id: "getting_started",
    label: "Getting Started",
    color: "text-brand",
    dot: "bg-brand",
    bg: "bg-brand/20",
    border: "border-brand",
    hex: "#F89C1D",
  },
  {
    id: "plans",
    label: "Plans & Sections",
    color: "text-brandSecondary",
    dot: "bg-brandSecondary",
    bg: "bg-brandSecondary/20",
    border: "border-brandSecondary",
    hex: "#4055FF",
  },
  {
    id: "mentor_circle",
    label: "Mentor Circle",
    color: "text-circle",
    dot: "bg-circle",
    bg: "bg-circle/20",
    border: "border-circle",
    hex: "#27AAE1",
  },
  {
    id: "for_youth",
    label: "For Youth",
    color: "text-vision",
    dot: "bg-vision",
    bg: "bg-vision/20",
    border: "border-vision",
    hex: "#ED1A79",
  },
  {
    id: "for_parents",
    label: "For Parents",
    color: "text-encouragement",
    dot: "bg-encouragement",
    bg: "bg-encouragement/20",
    border: "border-encouragement",
    hex: "#FBCD08",
  },
  {
    id: "privacy",
    label: "Privacy & Safety",
    color: "text-gifts",
    dot: "bg-gifts",
    bg: "bg-gifts/20",
    border: "border-gifts",
    hex: "#0A9347",
  },
  {
    id: "account",
    label: "Account",
    color: "text-commitments",
    dot: "bg-commitments",
    bg: "bg-commitments/20",
    border: "border-commitments",
    hex: "#57C9E8",
  },
]

export const FAQ_AUDIENCES = [
  { id: "youth", label: "Youth" },
  { id: "guide", label: "Guide" },
  { id: "mentor", label: "Mentor" },
  { id: "parent", label: "Parent" },
  { id: "everyone", label: "Everyone" },
]
